export default "//static.tradera.net/touchweb/static/output/images/category-watches.ba27b33f.svg";